var _path, _line, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAngulation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6543 25.9687C18.7819 25.9896 18.9043 26 19.0266 26C19.9681 26 20.766 25.3419 20.9894 24.4384C21.7766 21.2317 24 13.5649 24 11.5803C24 9.0525 21.9096 7 19.3351 7C18.6809 7 18.0585 7.13057 17.4947 7.37081C17.0213 7.56927 16.5106 7.67372 16 7.67372C15.4894 7.67372 14.9787 7.57449 14.5053 7.37081C13.9415 7.13057 13.3191 7 12.6649 7C10.0904 7 8 9.0525 8 11.5803C8 13.3194 10.2021 21.2317 10.9734 24.4384C11.1915 25.3419 11.9894 26 12.9362 26C13.0585 26 13.1862 25.9896 13.3138 25.9634C14.2713 25.7859 14.9362 24.9241 14.9362 23.9684V21.7905C14.9362 20.9601 15.4043 20.5006 15.984 20.5006C16.5638 20.5006 17.0319 20.9601 17.0319 21.5294V23.9684C17.0319 24.9241 17.6968 25.7911 18.6596 25.9687H18.6543Z",
    fill: "#70A4D4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 4,
    x2: 16,
    y2: 27,
    stroke: "#1A1A1A",
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6L3.27302 6.7315L6.77 11.3255L9 6ZM9 26L6.29888 20.8973L3.23039 25.7879L9 26ZM5.02845 8.41382C3.67323 10.1118 2.5 12.69 2.5 16.4999L3.5 16.4999C3.5 12.9129 4.59858 10.5555 5.81003 9.03762L5.02845 8.41382ZM2.5 16.4999C2.5 20.0783 3.53562 22.4176 4.80572 23.9302L5.57154 23.2871C4.47016 21.9755 3.5 19.8717 3.5 16.4999L2.5 16.4999Z",
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 6L28.727 6.7315L25.23 11.3255L23 6ZM23 26L25.7011 20.8973L28.7696 25.7879L23 26ZM26.9715 8.41382C28.3268 10.1118 29.5 12.69 29.5 16.4999L28.5 16.4999C28.5 12.9129 27.4014 10.5555 26.19 9.03762L26.9715 8.41382ZM29.5 16.4999C29.5 20.0783 28.4644 22.4176 27.1943 23.9302L26.4285 23.2871C27.5298 21.9755 28.5 19.8717 28.5 16.4999L29.5 16.4999Z",
    fill: "#1A1A1A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15,
    r: 2,
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAngulation);
export default __webpack_public_path__ + "static/media/Icon_Angulation.128a966752f00999a8384919a552ea0b.svg";
export { ForwardRef as ReactComponent };